<template>
  <div class="flex flex-col lg:h-0 lg:min-h-full">
    <div class="flex-none px-2">
      <h5 class="text-sm font-medium text-gray-600 mb-2">Notes</h5>
    </div>
    <div class="flex-1 lg:h-0">
      <div class="h-full overflow-auto fancy-scrollbar px-2">
        <div>
          <div class="bg-white p-4 rounded border border-gray-400">
            <ValidationObserver ref="observer">
              <template #default="{ handleSubmit, invalid }">
                <form @submit.prevent="handleSubmit(doSubmit)">
                  <BaseLayoutSpaced>
                    <ValidationProvider ref="notes" vid="notes" name="notes" slim>
                      <template #default="{ errors, failed }">
                        <BaseFormTextarea
                          v-model="data.notes"
                          :disabled="updating"
                          rows="20"
                          name="notes"
                          class="text-sm"
                        />
                        <BaseFormInlineMessage v-if="failed" danger>
                          {{ errors[0] }}
                        </BaseFormInlineMessage>
                      </template>
                    </ValidationProvider>

                    <div>
                      <BaseButton type="submit" primary :disabled="updating || invalid">
                        Update
                      </BaseButton>
                    </div>
                  </BaseLayoutSpaced>
                </form>
              </template>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP_UNPROCESSABLE_ENTITY } from '@/api/http-response-codes';
import veeValidateErrorsMixin from '@/mixins/veeValidateErrorsMixin';

export default {
  mixins: [veeValidateErrorsMixin],
  props: {
    contactRequest: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      data: {
        notes: '',
      },
      updating: false,
    };
  },
  watch: {
    contactRequest: {
      deep: true,
      handler(contactRequest) {
        if (!contactRequest) return;

        this.data.notes = contactRequest.notes;
      },
    },
  },
  created() {
    const { notes = '' } = this.contactRequest || {};

    this.data.notes = notes;
  },
  methods: {
    async doSubmit() {
      const { id } = this.contactRequest;
      this.errorMessage = '';
      this.updating = true;

      try {
        await this.$store.dispatch('ui/contactRequests/update', { id, formData: this.data });
      } catch (response) {
        const { data: { message = '', errors = {} } = {}, status = null } = response || {};
        this.errorMessage = message;
        if (status === HTTP_UNPROCESSABLE_ENTITY) {
          this.applyServerErrors(errors);
        }
      } finally {
        this.updating = false;
      }
    },
    applyServerErrors(errors) {
      this.observer = this.$refs.observer;
      this.addServerErrors(errors);
    },
  },
};
</script>
